function initialState() {
  return {
    post: {
      startSending: null,
      stopSending: null,
      publishDate: null,
      title: "",
      contentHtml: "",
      format: "large",
      imageTargetUrl: null,
      rules: {
        browserLanguage: {
          isNegated: false,
          values: [],
        },
        plans: {
          isNegated: false,
          values: ["FREE"],
          maxTimeToTrialEnd: null,
        },
        geoPricingAvailable: null,
        newCustomer: null,
        minAccountAge: null,
        maxAccountAge: null,
      },
    },
    posts: [],
  }
}

let state = initialState()

export {
  initialState,
  state
}
